import { useCallback } from 'react';
import { getContainer } from '@framework/di/getContainer';
import { useDocumentGroupContext } from '@/creditflowresearch/application/Research/DocumentGroupContext';
import DocumentGroup from '@/creditflowresearch/domain/DocumentGroup';
import { IRedirectInfo } from '@/creditflowresearch/application/Research/types';

export const useDocumentGroupValidation = (groupName: string) => {
  const container = getContainer();
  const { collection: documentGroupCollection } = useDocumentGroupContext();

  return useCallback((): IRedirectInfo => {
    const documentGroupService = container.get(DocumentGroup);
    const documentGroup = documentGroupService.getByGroupName(documentGroupCollection, groupName);
    const redirectParams: Record<string, any> = {};

    if (!documentGroupService.isValid(documentGroupCollection, groupName)) {
      // @ts-ignore TODO: incorrect type of payload with correct repository type
      const defaultDocumentGroup = documentGroupService.getDefault(documentGroupCollection);
      redirectParams.documentGroup = defaultDocumentGroup;
      return {
        shouldRedirect: true,
        // @ts-ignore TODO: incorrect type of payload with correct repository type
        documentGroup: defaultDocumentGroup,
        redirectParams,
      };
    }

    redirectParams.documentGroup = documentGroup;
    return {
      shouldRedirect: false,
      documentGroup,
      redirectParams,
    };
  }, [container, documentGroupCollection, groupName]);
};
